<template>
    <Popup :show="show" v-on:closeEvent="close">
        <div class="popup-container">
        <div class="circle">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858Z" fill="white"/>
            </svg>
        </div>
        <h2>{{$t("donate.LBL_TRANS_FAILED_HEADER")}}</h2>
        <span class="text" v-html="description?description:$t('donate.LBL_TRANS_FAILED_DEFAULT_CONTENT')"></span>
        <div class="buttons">
            <button class="button" @click="ok">
                <span>{{$t("strings.BTN_CONTINUE")}}</span>
            </button>
        </div>
        </div>
    </Popup>
</template>

<script>
    import Popup from '@/components/Popup';

    export default {
        name: "OrderErrorPopup",
        components: {
            Popup
        },
        props: {
            show: {
                type: Boolean,
                required: true
            },
            description:{
                type: String,
                required: false
            }
        },
        methods: {
            close(){
                this.$emit('closeEvent', null);
            },
            ok() {
                this.$emit('closeEvent', null);
            }   
        }
    }
</script>

<style scoped lang="scss">
    .popup-container {
        width: 100%;
        align-self: auto;
        display: flex;
        flex-direction: column;
    }
    .buttons {
        width: 100%;
        display: flex;
        margin-top: auto;
        .button {
            margin-left: auto;
        }
    }
</style>
